import React, { useState } from "react";
import "./index.css";
import logo from "./logo.png";
import mcImg from "./minecraft.jpg"; 
import pyImg from "./python.jpg";
import nodeImg from "./nodejs.jpg";

const products = [
  {
    name: "GameServer Minecraft",
    image: mcImg,
    description: "Seleziona il piano che preferisci per il tuo server Minecraft.",
    isMinecraft: true,
  },
  {
    name: "Host Python",
    image: pyImg,
    description: "0.5 Core\n500MB RAM\n1GB SSD",
    price: "€0.50/mese",
  },
  {
    name: "Host NodeJS",
    image: nodeImg,
    description: "0.5 Core\n500MB RAM\n1GB SSD",
    price: "€0.50/mese",
  },
];

function App() {
  const [showPopup, setShowPopup] = useState(false);
  const [closing, setClosing] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState("Eco");

  const minecraftPlans = {
    Eco: {
      description: "1 Core\n4GB RAM\n50GB SSD",
      price: "€3/mese",
    },
    Standard: {
      description: "2 Core\n8GB RAM\n80GB SSD",
      price: "€5/mese",
    },
  };

  const openPopup = () => {
    setShowPopup(true);
    setSelectedPlan("Eco"); 
  };

  const closePopup = () => {
    setClosing(true);
    setTimeout(() => {
      setShowPopup(false);
      setClosing(false);
    }, 400);
  };

  return (
    <div className="app">
      <header className="header">
        <img src={logo} alt="GalaxyHosting Logo" className="logo" />
        <h1>GalaxyHosting</h1>
      </header>
      <main className="products-container">
        {products.map((product, index) => (
          <div className="product-card" key={index}>
            <img src={product.image} alt={product.name} className="product-image" />
            <h2>{product.name}</h2>
            <p>{product.description}</p>
            {product.isMinecraft ? (
              <button className="select-button" onClick={openPopup}>Seleziona</button>
            ) : (
              <>
                <p className="product-price">{product.price}</p>
                <a href="https://t.me/GalaxyHostingBot" target="_blank" rel="noopener noreferrer">
                  <button className="buy-button">Acquista</button>
                </a>
              </>
            )}
          </div>
        ))}
      </main>
      <footer className="footer">
        <p>Contattaci su Telegram: @GalaxyHosting</p>
      </footer>

      {/* Popup Minecraft */}
      {showPopup && (
        <div className="popup-overlay" onClick={closePopup}>
          <div
            className={`popup ${closing ? "closing" : ""}`}
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-button" onClick={closePopup}>×</button>
            <h2>Seleziona Piano Minecraft</h2>

            <div className="toggle-container">
              <button
                className={`toggle-button ${selectedPlan === "Eco" ? "active" : ""}`}
                onClick={() => setSelectedPlan("Eco")}
              >
                Eco
              </button>
              <button
                className={`toggle-button ${selectedPlan === "Standard" ? "active" : ""}`}
                onClick={() => setSelectedPlan("Standard")}
              >
                Standard
              </button>
            </div>

            <div className="stats">
              {minecraftPlans[selectedPlan].description}
            </div>
            <div className="popup-price">
              {minecraftPlans[selectedPlan].price}
            </div>

            <a href="https://t.me/GalaxyHostingBot" target="_blank" rel="noopener noreferrer">
              <button className="buy-button">Acquista</button>
            </a>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
